import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { SearchIcon } from '~components/ui/icons';

export function AdminProfilesSearchBar({
  search,
  handleSetSearch,
}: {
  search: string;
  handleSetSearch: (searchText: string) => void;
}) {
  const [searchText, setSearchText] = useState(search);

  useEffect(() => {
    setSearchText(search);
  }, [search]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSetSearch(searchText.trim());
    }
  };

  return (
    <InputGroup width="full" maxWidth="sm">
      <InputLeftElement pointerEvents="none" height="full">
        <SearchIcon color="gray.500" />
      </InputLeftElement>
      <Input
        type="text"
        placeholder={t('searchForUserPlaceholder')}
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
        onBlur={() => handleSetSearch(searchText.trim())}
        onKeyDown={handleKeyDown}
        variant="outline"
        size="md"
      />
    </InputGroup>
  );
}
